import { ApiKey, TenantAccess, User } from '@/entities'
import { ObjectId } from '@/utils/objectid'

export const getTenantAccess = ({
    user,
    apiKey,
    tenantId,
}: {
    user?: User | null
    apiKey?: ApiKey | null
    tenantId: ObjectId
}) => {
    let tenantAccess: TenantAccess | undefined = undefined

    if (apiKey) {
        if (apiKey.tenant.equals(tenantId)) {
            tenantAccess = {
                tenant: apiKey.tenant,
                owner: false,
                permissions: apiKey.permissions,
                restrictions: apiKey.restrictions,
            }
        }
    } else if (user) {
        tenantAccess = user.tenants.find(({ tenant: t }) => t.equals(tenantId))
    }

    return tenantAccess
}
